export default __webpack_public_path__ + "120565754e375f92f068b896fb8cccd4.png";